import React from 'react';
import { Link } from 'react-router-dom';
import DailyCheckIn from './DailyCheckIn';

import './DailyCheckInContainer.scss';

export default function DailyCheckInContainer() {
  return (
    <div className="container daily-checkin-container mt-4">
      <div className="font-weight-600">
        <Link to="/analytics">Analytics</Link> / Daily Check-In Report
      </div>

      <div className="d-flex align-items-center justify-content-between mt-4">
        <h2 className="av-blue font-weight-600 m-0">Daily Check-In Report</h2>
      </div>

      <DailyCheckIn />
    </div>
  );
}
